var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3431 13.8468C10.3124 13.8468 8.36487 14.6535 6.92893 16.0894L2.24264 20.7757C0.8067 22.2117 0 24.1592 0 26.1899C0 30.4187 3.42809 33.8468 7.65687 33.8468C9.6876 33.8468 11.6351 33.0401 13.0711 31.6041L16.3126 28.3626C16.3126 28.3625 16.3127 28.3627 16.3126 28.3626L25.7573 18.9179C26.4431 18.2321 27.3733 17.8468 28.3431 17.8468C29.9669 17.8468 31.3435 18.9051 31.8207 20.3695L34.8015 17.3888C33.4417 15.259 31.0573 13.8468 28.3431 13.8468C26.3124 13.8468 24.3649 14.6535 22.9289 16.0894L10.2427 28.7757C9.55687 29.4615 8.62673 29.8468 7.65687 29.8468C5.63723 29.8468 4 28.2096 4 26.1899C4 25.2201 4.38527 24.2899 5.07107 23.6041L9.75733 18.9179C10.4431 18.2321 11.3733 17.8468 12.3431 17.8468C13.9669 17.8468 15.3435 18.9051 15.8207 20.3696L18.8015 17.3888C17.4417 15.2591 15.0574 13.8468 12.3431 13.8468Z",
    fill: "#394149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2427 28.7757C25.5569 29.4615 24.6268 29.8468 23.6569 29.8468C22.0334 29.8468 20.6569 28.7888 20.1795 27.3246L17.1989 30.3053C18.5587 32.4347 20.9429 33.8468 23.6569 33.8468C25.6877 33.8468 27.6352 33.0401 29.0711 31.6041L41.7574 18.9179C42.4432 18.2321 43.3733 17.8468 44.3432 17.8468C46.3629 17.8468 48 19.484 48 21.5037C48 22.4735 47.6148 23.4037 46.929 24.0895L42.2427 28.7757C41.5569 29.4615 40.6268 29.8468 39.6569 29.8468C38.0332 29.8468 36.6567 28.7886 36.1794 27.3243L33.1987 30.305C34.5585 32.4347 36.9428 33.8468 39.6569 33.8468C41.6876 33.8468 43.6352 33.0401 45.0711 31.6041L49.7574 26.9179C51.1933 25.4819 52 23.5344 52 21.5037C52 17.2749 48.572 13.8468 44.3432 13.8468C42.3125 13.8468 40.3649 14.6535 38.929 16.0894L26.2427 28.7757Z",
    fill: "#394149"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 20,
    fill: "white",
    transform: "translate(0 13.8468)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo6);
export default __webpack_public_path__ + "static/media/Logo6.e4439ec387a05d9d1e024f1eb2e71be9.svg";
export { ForwardRef as ReactComponent };